
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scout/datasets",
      function () {
        return require("private-next-pages/scout/datasets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scout/datasets"])
      });
    }
  